export const QUOTE_OPERATION_MODES = {
  DEFAULT: 'DEFAULT',
  REVISION: 'REVISION',
  CLONE: 'CLONE',
};

export const QUOTE_OPERATION_MODES_LIST = Object.keys(QUOTE_OPERATION_MODES);
